function saveSelectedMediaIndex(idx) {
  const last_idx = document.getElementById('selected_image_index').value;
  document.getElementById("imageContent-"+last_idx).style.display = 'block';
  document.getElementById('selected_image_index').value = idx;
  document.getElementById('animlContent').style.display = 'none';
}

function displayView3D() {
  const idx = document.getElementById('selected_image_index').value;
  document.getElementById('animlContent').style.display = 'block';
  if(window.innerWidth>768) {
    document.getElementById("imageContent-"+idx).style.display = 'none';
  }
}

const iframe = document.getElementById('animl-modal-content-iframe');
if(window.innerWidth>768) {
  let calculated_width = window.innerWidth / 2.2;
  if(calculated_width > 800){
    calculated_width = 800;
  }
  iframe.style.width = calculated_width+'px';
  iframe.style.height = calculated_width+'px';
} else {
  let calculated_width = window.innerWidth * 0.9;
  iframe.style.width = calculated_width+'px';
  iframe.style.height = calculated_width+'px';
  iframe.style.marginRight = "5%";
  iframe.style.marginLeft = "5%";
}

window.addEventListener('resize', () => {
  if(window.innerWidth>768) {
    let calculated_width = window.innerWidth / 2.2;
    if(calculated_width > 800){
      calculated_width = 800;
    }
    iframe.style.width = calculated_width+'px';
    iframe.style.height = calculated_width+'px';
  } else {
    let calculated_width = window.innerWidth * 0.9;
    iframe.style.width = calculated_width+'px';
    iframe.style.height = calculated_width+'px';
    iframe.style.marginRight = "5%";
    iframe.style.marginLeft = "5%";
  }
});